import { Box, Link } from '@mui/material';
import { Auth } from 'aws-amplify';
import { useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';

import { ReactComponent as LogOutIcon } from '@/assets/icons/bx-log-out.svg';

import { SideMenuItems } from './SideMenuItems';
import { TreeGroup, TreeGroupItem } from './TreeGroup';

type SideMenuProps = {
  isOpen: boolean;
};

export const SideMenu = ({ isOpen }: SideMenuProps) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const initialSelectedMenuItemId = useMemo(() => {
    for (const group of SideMenuItems) {
      for (const subMenu of group.subMenus) {
        if (pathname === subMenu.to) {
          return subMenu.id;
        }

        if (subMenu.activePathPrefixes?.some((prefix) => pathname.startsWith(prefix))) {
          return subMenu.id;
        }
      }
    }

    return null;
  }, [pathname]);

  const [selectedMenuItemId, setSelectedMenuItemId] = useState<string | null>(initialSelectedMenuItemId);

  return (
    <Box
      sx={{
        width: isOpen ? '240px' : '0px',
        height: '100%',
        minHeight: 0,
        background: '#FFFFFF',
        position: 'relative',
        overflow: 'hidden',
        transition: 'width 0.2s ease',
      }}
    >
      <Box
        sx={{
          width: '240px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: '24px',
          paddingTop: '16px',
          paddingBottom: '30px',
          overflowY: 'auto',
          height: '100%',
          borderRight: '1px solid #D1D5DB',
        }}
      >
        {SideMenuItems.map((item: TreeGroupItem, index: number) => {
          const id = index;
          return (
            <TreeGroup
              key={id}
              treeGroupItem={item}
              selectedMenuItemId={selectedMenuItemId}
              onSelectMenuItem={setSelectedMenuItemId}
              navigate={navigate}
            />
          );
        })}
        <Link
          component="button"
          underline="none"
          onClick={() => Auth.signOut()}
          sx={{
            width: '207px',
            height: '42px',
            marginX: '16px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '12px',
            padding: '9px 17px 9px 15px',
            boxSizing: 'border-box',
            borderRadius: '6px',
            border: '1px solid #D1D5DB',
            textAlign: 'left',
            fontFamily: 'Inter, sans-serif',
            fontWeight: 500,
            fontSize: '16px',
            lineHeight: '24px',
            letterSpacing: '0',
            color: '#374151',
          }}
        >
          <LogOutIcon style={{ width: '20px', height: '20px' }} />
          ログアウト
        </Link>
      </Box>
    </Box>
  );
};
